// Leveled logger. Every subsystem gets one tagged with its name so console
// output is greppable. Levels: silent < error < warn < info < debug.

const LEVELS = { silent: 0, error: 1, warn: 2, info: 3, debug: 4 };

export function createLogger(name, level = 'warn') {
  const threshold = LEVELS[level] ?? LEVELS.warn;
  const tag = `[${name}]`;
  const bind = (lvl, fn) => (...args) => {
    if (LEVELS[lvl] <= threshold) fn(tag, ...args);
  };
  const c = console;
  return {
    error: bind('error', c.error.bind(c)),
    warn: bind('warn', c.warn.bind(c)),
    info: bind('info', (c.info || c.log).bind(c)),
    debug: bind('debug', (c.debug || c.log).bind(c)),
  };
}
